export default __webpack_public_path__ + "static/newsroom_header-4e60a1678c815cba3bdd27074f5d3787.png";